// 예약 생성하기
export const POST_RESERVATION_REQUEST = 'GET_REVIEW_LIST_REQUEST';
export const POST_RESERVATION_SUCCESS = 'GET_REVIEW_LIST_SUCCESS';
export const POST_RESERVATION_FAIL = 'GET_REVIEW_LIST_FAIL';
// 나의예약 조회하기
export const GET_MY_RESERVATION_REQUEST = 'GET_MY_RESERVATION_REQUEST';
export const GET_MY_RESERVATION_SUCCESS = 'GET_MY_RESERVATION_SUCCESS';
export const GET_MY_RESERVATION_FAIL = 'GET_MY_RESERVATION_FAIL';
// 선택된 예약
export const SET_SELECTED_RESERVATION = 'SET_SELECTED_RESERVATION';
// 나의예약 상세내역
export const GET_MY_RESERVE_DETAIL_REQUEST = 'GET_MY_RESERVE_DETAIL_REQUEST';
export const GET_MY_RESERVE_DETAIL_SUCCESS = 'GET_MY_RESERVE_DETAIL_SUCCESS';
export const GET_MY_RESERVE_DETAIL_FAIL = 'GET_MY_RESERVE_DETAIL_FAIL';
// 예매취소
export const CANCEL_RESERVATION_REQUEST = 'CANCEL_RESERVATION_REQUEST';
export const CANCEL_RESERVATION_SUCCESS = 'CANCEL_RESERVATION_SUCCESS';
export const CANCEL_RESERVATION_FAIL = 'CANCEL_RESERVATION_FAIL';

// 나의예약 조회하기(날짜 기준)
export const GET_MY_RESERVATION_BYDATE_REQUEST = 'GET_MY_RESERVATION_BYDATE_REQUEST';
export const GET_MY_RESERVATION_BYDATE_SUCCESS = 'GET_MY_RESERVATION_BYDATE_SUCCESS';
export const GET_MY_RESERVATION_BYDATE_FAIL = 'GET_MY_RESERVATION_BYDATE_FAIL';